export const getPendingOrderCartResetPayload = () => ({
  commande: {},
  totalPriceOrder: 0,
  totalProductPriceOrder: 0,
  totalProductPriceWithPromo: 0,
});

export const getEmptyPendingOrderPayload = () => ({
  shopId: null,
  address: null,
  ...getPendingOrderCartResetPayload(),
});

